var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1282 153.98L232.034 252.968C243.337 258.651 256.663 258.651 267.966 252.968L464.872 153.98C476.566 148.101 476.639 131.434 464.997 125.453L268.279 24.3905C256.806 18.4963 243.194 18.4963 231.721 24.3905L35.0032 125.453C23.3614 131.434 23.4344 148.101 35.1282 153.98Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3586 208.25L222.096 273.636C239.092 282.008 259.012 282.008 276.007 273.636L409.252 208L464.326 235.853C476.088 241.801 476.015 258.624 464.202 264.471L267.294 361.916C256.113 367.449 242.992 367.449 231.811 361.916L34.9034 264.471C23.0896 258.624 23.0166 241.801 34.7792 235.853L89.3586 208.25Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.096 383.636L89.3586 318.25L34.7792 345.853C23.0166 351.801 23.0896 368.624 34.9034 374.471L231.811 471.916C242.992 477.449 256.113 477.449 267.294 471.916L464.202 374.471C476.015 368.624 476.088 351.801 464.326 345.853L409.252 318L276.007 383.636C259.012 392.008 239.092 392.008 222.096 383.636Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapLayers);
export default __webpack_public_path__ + "static/media/ico_map_layers.afebd4ccdec91927a797e584c35da32a.svg";
export { ForwardRef as ReactComponent };